export const applicanttrackinginterviewfeedbackdata = [
  {
    Applicant: "John Smith",
    Job: "Software Engineer",
    Date: "01-02-2025",
    Status: "Interviewed",
    Reason: "Waiting for final decision",
    Mode: "Virtual",
    Company: "Tech Solutions Inc.",
  },
  {
    Applicant: "Emily Davis",
    Job: "UX Designer",
    Date: "07-03-2025",
    Status: "Pending",
    Reason: "Awaiting Feedback",
    Mode: "In-person",
    Company: "Design Co.",
  },
  {
    Applicant: "Daniel Carter",
    Job: "Product Manager",
    Date: "15-01-2025",
    Status: "Rejected",
    Reason: "Position filled",
    Mode: "Virtual",
    Company: "Innovative Tech",
  },
  {
    Applicant: "Sophia Martinez",
    Job: "Data Analyst",
    Date: "22-02-2025",
    Status: "Interviewed",
    Reason: "Second round scheduled",
    Mode: "In-person",
    Company: "DataTech Analytics",
  },
  {
    Applicant: "Michael Lee",
    Job: "Marketing Specialist",
    Date: "03-03-2025",
    Status: "Pending",
    Reason: "Awaiting Feedback",
    Mode: "Virtual",
    Company: "Creative Agency",
  },
  {
    Applicant: "Lily Johnson",
    Job: "Graphic Designer",
    Date: "05-01-2025",
    Status: "Accepted",
    Reason: "Offer made",
    Mode: "In-person",
    Company: "Brand Innovators",
  },
  {
    Applicant: "Lucas Wilson",
    Job: "Web Developer",
    Date: "20-02-2025",
    Status: "Pending",
    Reason: "Awaiting Interview Scheduling",
    Mode: "Virtual",
    Company: "Web Solutions Ltd.",
  },
  {
    Applicant: "Amelia Brown",
    Job: "HR Manager",
    Date: "12-01-2025",
    Status: "Rejected",
    Reason: "Not a good fit",
    Mode: "In-person",
    Company: "HR Partners",
  },
  {
    Applicant: "Ethan Harris",
    Job: "Full Stack Developer",
    Date: "10-02-2025",
    Status: "Interviewed",
    Reason: "Waiting for offer",
    Mode: "Virtual",
    Company: "DevWorks",
  },
  {
    Applicant: "Isabella Clark",
    Job: "Content Writer",
    Date: "25-02-2025",
    Status: "Pending",
    Reason: "Awaiting Feedback",
    Mode: "In-person",
    Company: "Creative Content",
  },
  {
    Applicant: "James Robinson",
    Job: "Product Designer",
    Date: "14-03-2025",
    Status: "Interviewed",
    Reason: "Second round scheduled",
    Mode: "Virtual",
    Company: "Design Group",
  },
  {
    Applicant: "Chloe Wilson",
    Job: "Business Analyst",
    Date: "28-02-2025",
    Status: "Pending",
    Reason: "Awaiting Feedback",
    Mode: "Virtual",
    Company: "Analysis Corp.",
  },
  {
    Applicant: "Matthew Taylor",
    Job: "Project Manager",
    Date: "09-03-2025",
    Status: "Rejected",
    Reason: "Position closed",
    Mode: "In-person",
    Company: "ManageIt",
  },
  {
    Applicant: "Charlotte Martinez",
    Job: "SEO Specialist",
    Date: "02-03-2025",
    Status: "Accepted",
    Reason: "Offer made",
    Mode: "Virtual",
    Company: "Digital Experts",
  },
  {
    Applicant: "Benjamin King",
    Job: "System Administrator",
    Date: "18-01-2025",
    Status: "Pending",
    Reason: "Awaiting Interview Scheduling",
    Mode: "In-person",
    Company: "Tech Solutions",
  },
];
